import { makeLazyComponent } from '../utils/lazy';

export const LazyMarkdown = makeLazyComponent(
  async () => (await import(/* webpackChunkName: "markdown" */ './RichMarkdownIt')).RichMarkdownIt,
);
